import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import AlternateEmailRoundedIcon from '@mui/icons-material/AlternateEmailRounded'
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded'
import VisibilityOffRoundedIcon from '@mui/icons-material/VisibilityOffRounded'
import store from '../store/store'


export default function Signin() {
    const isMenuOpen = store((state) => state.isMenuOpen)
    const setIsMenuOpen = store((state) => state.setIsMenuOpen)
    const isUserLogged = store((state) => state.isUserLogged)
    const setIsUserLogged = store((state) => state.setIsUserLogged)

    const [error, setError] = useState({email: false, password: false})
    const [displayPassword, setDisplayPassword] = useState(false)

    const navigate = useNavigate()

    // auto close the menu once the page is loaded
    useEffect(() => {
        if (isMenuOpen) {
            setIsMenuOpen(false)
        }
    },[])

    // Scroll to the top of the page when the component mounts
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])

    useEffect(()=> {
        if (isUserLogged)
        navigate('/search')
    },[isUserLogged])

    // check the credentials
    const handleSubmit = () => {
        const email = document.getElementById('sign_input_email').value
        const password = document.getElementById('sign_input_password').value

        if(email === ''){
            setError({...error, email: true})
        } else {
            setError({...error, email: false})
        }

        if(password === ''){
            setError({...error, password: true})
        } else {
            setError({...error, password: false})
        }

        if (email !== '' && password !== ''){
            setIsUserLogged(true)
            }
        
    }

    if (!isUserLogged) {
        return ( 
            <main>
                <div id='sign_background'>
                    <div id='sign_form'>
                        <div id='sign_form_heading'>
                            <h1>Welcome!</h1>
                            <h4>Please enter your credentials to sign in</h4>
                        </div>
                        { error.email || error.password? <p id='sign_error_field'>Oops! Something's wrong! Check your credentials again!</p> : null }
                        <div id='sign_form_inputs'>
                            <label id='sign_email'>
                                <div className='input_wrapper'>
                                    <input id='sign_input_email' type="email" name="email" placeholder='Email' />
                                    <AlternateEmailRoundedIcon id='sign_icon'/>
                                </div>
                            </label>
                            
                            <label id='sign_password'>
                                <div className='input_wrapper'>
                                    <input id='sign_input_password' type={displayPassword? 'text' : 'password'} name="password" placeholder='Password'  />
                                    {displayPassword?
                                        <VisibilityRoundedIcon id='sign_icon_click' onClick={() => setDisplayPassword(!displayPassword)}/>
                                        :
                                        <VisibilityOffRoundedIcon id='sign_icon_click' onClick={() => setDisplayPassword(!displayPassword)} />
                                    }
                                </div>
                            </label>
                        </div>
                        <p id='sign_trouble' onClick={() => console.log('navigate to trouble login page')}>Having trouble to sign in?</p>
                        <button id='sign_button' onClick={handleSubmit}>Sign In</button>
                        <p id='sign_signup'>Don't have an account? <strong><Link to='/signup' id='sign_no_account_link' >go sign up</Link></strong></p>
                    </div>
                </div>
            </main>
        )
    }    
}
